import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getTaskByToken,
  completeTask,
  declineTask,
  addComment,
} from "../infrastructure/taskCompletionService"
import { TaskActionRequest, AddCommentRequest } from "../dto/taskCompletionDto"

export function useTaskCompletion(
  token: string | undefined,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: ["taskCompletion", token],
    queryFn: () => getTaskByToken(token!),
    enabled: !!token && enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}

export function useCompleteTask(token: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ request, captchaToken }: { request: TaskActionRequest; captchaToken?: string }) =>
      completeTask(token, request, captchaToken),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["taskCompletion", token] })
    },
    onError: (error) => {
      console.error("Task completion failed:", error)
    },
  })
}

export function useDeclineTask(token: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ request, captchaToken }: { request: TaskActionRequest; captchaToken?: string }) =>
      declineTask(token, request, captchaToken),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["taskCompletion", token] })
    },
    onError: (error) => {
      console.error("Task decline failed:", error)
    },
  })
}

export function useAddComment(token: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ request, captchaToken }: { request: AddCommentRequest; captchaToken?: string }) =>
      addComment(token, request, captchaToken),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["taskCompletion", token] })
    },
    onError: (error) => {
      console.error("Add comment failed:", error)
    },
  })
}
